/* eslint-disable jsx-a11y/label-has-associated-control */
import DateFnsUtils from '@date-io/date-fns';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import Image from '../common/Image';

const useStyle = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '25px',
  },
  calender: {
    width: '98%',
    display: 'flex',
    gap: '20px',
  },
  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
    marginTop: '9px',
    marginBottom: '9px',
  },
  journey: {
    width: '98%',
  },
  heading: {
    fontSize: '18px',
    fontWeight: '700',
    width: '98%',
  },
  journeyBox: {
    width: '50%',
    height: '100px',
    padding: '10px',
    borderRadius: '6px',
    background: '#fff',
    display: 'flex',
    gap: '10px',
    marginTop: '10px',
  },
  journeyContent: {
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
});

export default function AssignDueDate({ dueDate, setDueDate, selectedJ }) {
  const classes = useStyle();

  // Get today's date
  const today = new Date();

  const handleDateChange = (date) => {
    setDueDate(date);
  };

  return (
    <Grid className={classes.container}>
      <Grid className={classes.journey}>
        <Typography className={classes.heading}>Selected Journey</Typography>
        <Grid style={{ width: '98%' }}>
          <Grid className={classes.journeyBox}>
            <Grid style={{ width: '20%' }}>
              <Image
                src={selectedJ.thumbnail}
                alt="profile"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Grid>
            <Grid className={classes.journeyContent}>
              <Typography style={{ fontSize: '16px', fontWeight: '700' }}>{selectedJ.title}</Typography>
              <Typography varient="p" style={{ fontSize: '12px' }}>
                ID: {selectedJ.id}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div style={{ height: '1px', width: '98%', background: '#E4E7EC' }}></div>
      <Grid className={classes.calender}>
        <Grid item style={{ width: '100%' }}>
          <div className={classes.popupLabels}>
            <label htmlFor="courseOverview" className={classes.required_field}>
              Due Date
            </label>
          </div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              placeholder="YYYY-MM-DD"
              value={dueDate}
              onChange={handleDateChange}
              InputProps={{
                disableUnderline: true,
                classes: {
                  input: 'date-field',
                },
              }}
              format="yyyy-MM-dd"
              style={{
                width: '95%',
                backgroundColor: 'white',
                height: '40px',
                borderRadius: 8,
                padding: '10px',
              }}
              minDate={today}
              maxDate={new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </Grid>
  );
}
